import React, { useMemo, useRef } from "react";
import * as echarts from "echarts/core";
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DataZoomComponent,
  BrushComponent,
  LegendComponent,
} from "echarts/components";
import { LineChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";
import EChartCommon from "@op/components/EChartCommon";
import CardCommon from "@op/components/CardCommon";
import { Layout } from "tea-component";
import ContentBody from "@op/components/ContentBody";
import moment from "moment";
const { Content } = Layout;

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DataZoomComponent,
  BrushComponent,
  LegendComponent,
  LineChart,
  CanvasRenderer,
]);


export default function DemoChart() {
  const chartRef = useRef<any>(null);
  // 🔹 Function to handle brush selection
  const handleBrushSelected = (params: any) => {
    const echartsInstance = chartRef.current?.getEchartsInstance?.();
    if (!echartsInstance) return;

    const brushed: { seriesIndex: number; dataIndex: number[] }[] =
      params.batch[0].selected;

    const selectedData: any[] = [];
    brushed.forEach((item) => {
      const seriesData = echartsInstance.getOption().series[item.seriesIndex]
        .data as [number, number][];
      item.dataIndex.forEach((idx) => {
        selectedData.push(seriesData[idx]);
      });
    });

    console.log("👉 Selected data from brush:", selectedData);
    // Here you can pass the selectedData to parent / API call / state
  };
  // Brush event handlers
  const onBrushSelected = (params: any) => {
    console.log('Brush selected:', params);

    if (params.areas && params.areas.length > 0) {
      const brushArea = params.areas[0];
      const [startIndex, endIndex] = brushArea.coordRange;

      console.log(`Selected range: ${startIndex} to ${endIndex}`);
      console.log(`Time range: ${timeArr[startIndex]} to ${timeArr[endIndex]}`);

      // Get selected data
      const selectedData1 = data1.slice(startIndex, endIndex + 1);
      const selectedData2 = data2.slice(startIndex, endIndex + 1);

      console.log('Selected data:', { selectedData1, selectedData2 });

      // You can trigger other actions here, like:
      // - Update another chart
      // - Show statistics of selected range
      // - Save selection to state
      // - Call API with selected time range
    }
  };

  const onBrushEnd = (params: any) => {
    console.log('Brush end:', params);
    // Handle brush end event
  };

  // --- mock data generator ---
  const generateMockData = (count: number) => {
    const baseTime = moment("2025-09-08 07:30:00", "YYYY-MM-DD HH:mm:ss");
    const data1: number[] = [];
    const data2: number[] = [];
    const timeArr: string[] = [];

    for (let i = 0; i < count; i++) {
      const time = baseTime.clone().add(i * 5, "minutes");
      const formatted = time.format("YYYY-MM-DD HH:mm:ss");
      timeArr.push(formatted);
      data1.push(Math.round(Math.random() * 10));
      data2.push(Math.round(Math.random() * 10));
    }
    return { data1, data2, timeArr };
  };

  const { data1, data2, timeArr } = useMemo(() => generateMockData(200), []);

  const options = useMemo(() => {
    return {
      title: { text: "Realtime Trend Demo with Brush Event" },
      tooltip: { trigger: "axis" },
      legend: { data: ["Line A", "Line B"] },
      grid: { left: "5%", right: "5%", bottom: "15%", containLabel: true },
      xAxis: {
        type: "category", data: timeArr,
        formatter: (value: string) => moment(value).format("HH:mm"),
      },
      yAxis: { type: "value", data: timeArr },
      brush: {
        toolbox: ["lineX", "clear"],
        xAxisIndex: "all",
        brushMode: "single",      // allow one selection
        brushType: "lineX",       // default selection tool
        brushStyle: {
          borderWidth: 1,
          color: "rgba(0,0,255,0.1)",
          borderColor: "blue",
        },
        areas: [{
          brushType: 'lineX',
          coordRange: [50, 100],  // Default selection from index 50 to 100
          xAxisIndex: 0,
        }]
      },
      dataZoom: [
        { type: "inside", start: 0, end: 100 },
        { start: 0, end: 100 },
      ],
      series: [
        { name: "Line A", type: "line", showSymbol: false, data: data1 },
        { name: "Line B", type: "line", showSymbol: false, data: data2 },
      ],
    };
  }, [data1, data2]);

  return (
    <Content className="dbo-page dbo-performance">
      <ContentBody
        contentHeard={
          <Content.Header className="dbo-header" title={'EChart'}></Content.Header>
        }
      >
        <CardCommon>
          <EChartCommon
            ref={chartRef}
            options={options}
            height={400}
            style={{ height: 400, width: "100%" }}
            eventsDict={{
              brushselected: onBrushSelected,
              brushEnd: onBrushEnd,
            }}
          />
        </CardCommon>
      </ContentBody>
    </Content>
  );
}